/* eslint-disable react/jsx-props-no-spreading */

import React from 'react'
import { string, bool, node } from 'prop-types'
import { Button } from '@gympass/yoga'

import CircularProgress from '@components/CircularProgress'

function LoadingButton({ variant, loading, children, ...rest }) {
  return variant === 'outlined' ? (
    <Button.Outline {...rest}>
      {loading ? <CircularProgress /> : children}
    </Button.Outline>
  ) : (
    <Button {...rest}>{loading ? <CircularProgress /> : children}</Button>
  )
}

LoadingButton.propTypes = {
  variant: string,
  loading: bool,
  children: node.isRequired,
}

LoadingButton.defaultProps = {
  variant: 'default',
  loading: false,
}

export default LoadingButton
